export default {
      id: "arrow-drop-down-usage",
      viewBox: "0 -960 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#arrow-drop-down-usage",
      toString: function () {
        return this.url;
      }
    }